
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Progress } from 'element-ui';
import { State, Mutation } from 'vuex-class';
import { CountUp, CountUpOptions } from 'countup.js';
import { IORGSTATE } from '@/store/state.d';
import api from '@/api/org';

type Count<T, V> = {
  dayCount: T | V,
  monthCount: T | V,
  totalCount: T | V,
}

@Component({
  components: {
    Progress,
  },
})
export default class InfoCard extends Vue {
  @State(state => state.org.moduleUpdate.cost) curStatus!: boolean;

  @Mutation('org/SET_ORG_COST_STATUS') setCostStatus !: Function;

  private countUp: Count<CountUp, null> = {
    dayCount: null,
    monthCount: null,
    totalCount: null,
  };

  public $refs!: {
    day: HTMLElement,
    month: HTMLElement,
    total: HTMLElement,
  };

  private countOpts: CountUpOptions = {
    prefix: '￥',
    decimal: '.',
    decimalPlaces: 2,
  };

  private loading: Boolean = true;

  private percentage: Number = 0;

  private colors: Array<{ color: string, percentage: number }> = [
    { color: '#f56c6c', percentage: 50 },
    { color: '#1989fa', percentage: 100 },
  ];

  private countDefault: CountUpOptions = {
    prefix: '￥',
    decimal: '.',
    decimalPlaces: 2,
  }

  mounted() {
    this.countUp.dayCount = new CountUp(this.$refs.day, 0, this.countDefault);
    this.countUp.monthCount = new CountUp(this.$refs.month, 0, this.countDefault);
    this.countUp.totalCount = new CountUp(this.$refs.total, 0, this.countDefault);
    this.getOrgCost();
  }

  // 根据机构Pid来获取机构消费
  getOrgCost() {
    this.loading = true;
    api.getOrgCost({ orgPid: this.$route.params.pid || '' }).then((res: any) => {
      (this.countUp.dayCount as CountUp).update(res.dayCost);
      (this.countUp.monthCount as CountUp).update(res.monthCost);
      (this.countUp.totalCount as CountUp).update(res.totalCost);
      this.percentage = res.totalCost > 0
        ? Math.floor(res.monthCost * 100 / res.totalCost * 100) / 100 : 0;
      this.setCostStatus(false);
      this.loading = false;
    });
  }

  @Watch('curStatus', { immediate: false, deep: true })
  handleStatusChange(v: boolean) {
    if (v) this.getOrgCost();
  }
}
